// extracted by mini-css-extract-plugin
export default {"UserAccessPage":"UserAccessPage_UserAccessPage__fWpIE","UserAccessPageCard":"UserAccessPage_UserAccessPageCard__1UNke"};